import { Perm } from '../../core/permissions';
import type { SideNavItem } from '../../shared/side-nav';

export type OrgSettingsNavItem = SideNavItem & { permission?: string };

export const ORG_SETTINGS_NAV: { id: string; title: string; items: OrgSettingsNavItem[] }[] = [
  {
    id: 'system',
    title: 'System Settings',
    items: [
      { label: 'Dashboard', icon: 'dashboard', link: '/app/org-settings/dashboard', permission: Perm.dashboardRead },
      { label: 'Users', icon: 'users', link: '/app/org-settings/users', permission: Perm.usersRead },
      { label: 'Roles & Permissions', icon: 'roles', link: '/app/org-settings/roles', permission: Perm.rolesRead },
      { label: 'Workspaces', icon: 'workspaces', link: '/app/org-settings/workspaces', permission: Perm.workspacesRead },
      { label: 'Audit Trail', icon: 'audit', link: '/app/org-settings/audit', permission: Perm.auditRead },
      { label: 'Appearance', icon: 'appearance', link: '/app/org-settings/appearance', permission: Perm.appearanceRead },
      { label: 'Notifications', icon: 'notifications', link: '/app/org-settings/notifications', permission: Perm.notificationsRead },
    ],
  },
  {
    id: 'organization',
    title: 'Organization Settings',
    items: [
      { label: 'Plant / Branch', icon: 'plant', link: '/app/org-settings/plants', permission: Perm.orgStructureManage },
      { label: 'Department', icon: 'department', link: '/app/org-settings/departments', permission: Perm.orgStructureManage },
      { label: 'Designation', icon: 'designation', link: '/app/org-settings/designations', permission: Perm.orgStructureManage },
    ],
  },
];

export function firstOrgSettingsLink(hasPermission: (key: string) => boolean): string | null {
  for (const group of ORG_SETTINGS_NAV) {
    for (const item of group.items) {
      if (!item.permission || hasPermission(item.permission)) {
        return item.link;
      }
    }
  }
  return null;
}
